module.exports = __webpack_public_path__ + "img/unpin.550588d9.svg";